export const HOME = '/';
export const LOGIN = '/login';


